import React, { memo } from 'react';

import { type DateReadContent } from './date-read-content.ts';
import styles from './date-value-view.module.css';

/**
 * Layout-neutral Date presentation; application policy is resolved before rendering.
 */
export const DateValueView = memo(function DateValueView({
  content,
  showDisabledValue = false
}: {
  readonly content: DateReadContent;
  readonly showDisabledValue?: boolean;
}) {
  if (!content.text) {
    return null;
  }

  return (
    <span className={styles.value} data-disabled={showDisabledValue || undefined}>
      {content.text}
    </span>
  );
});
